import { c as _c } from "react/compiler-runtime";
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import type { CSSProperties, ReactNode } from 'react';
const overlayCardWidth = 'var(--overlay-card-w, 152px)';
type LogoOverlayRecommendationCardShellProps = {
  href: string;
  children: ReactNode;
  title?: string;
  staggerIndex?: number;
  external?: boolean;
  className?: string;
  /** Optional inline style to merge with (or override) the default width style. */
  style?: CSSProperties;
};
export default function LogoOverlayRecommendationCardShell(t0) {
  const $ = _c(16);
  const {
    href,
    children,
    title,
    staggerIndex,
    external: t1,
    className,
    style: styleProp
  } = t0;
  const external = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== staggerIndex) {
    t2 = staggerIndex !== undefined ? {
      "--card-delay": `${50 + staggerIndex * 20}ms`
    } : {};
    $[0] = staggerIndex;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== styleProp || $[3] !== t2) {
    t3 = {
      width: overlayCardWidth,
      ...t2,
      ...styleProp
    };
    $[2] = styleProp;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const style = t3 as CSSProperties;
  const t4 = external ? "_blank" : undefined;
  const t5 = external ? "noopener noreferrer" : undefined;
  const t6 = staggerIndex !== undefined && "animate-logo-overlay-card-enter";
  let t7;
  if ($[5] !== className || $[6] !== t6) {
    t7 = cn("group relative flex shrink-0 flex-col gap-1", t6, className);
    $[5] = className;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== children || $[9] !== href || $[10] !== style || $[11] !== t4 || $[12] !== t5 || $[13] !== t7 || $[14] !== title) {
    t8 = <Link href={href} target={t4} rel={t5} className={t7} style={style} title={title}>{children}</Link>;
    $[8] = children;
    $[9] = href;
    $[10] = style;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}